/**
 * Normalizes alphabetic strings by removing symbols and applying title case.
 *
 * - Converts "asd" or "ASD" to "Asd"
 * - Converts "asd ASD" to "Asd Asd"
 * - Replaces any non-letter characters (including digits and symbols) with spaces before normalizing
 */
export const toAlphabetTitleCase = (input: string | null | undefined): string => {
    if (!input) return '';

    // Replace all non alphabetic characters with spaces, collapse repeats, then trim.
    const alphaOnly = input.replace(/[^a-zA-Z]+/g, ' ').trim();
    if (!alphaOnly) return '';

    return alphaOnly
        .split(/\s+/)
        .map(word => {
            const lower = word.toLowerCase();
            if (lower === 'id') return 'ID';
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(' ');
};
